module.exports = __webpack_public_path__ + "assets/img/3c4994232d73fe4f43d5d1eb55844260.png";